import { render, staticRenderFns } from "./Male.vue?vue&type=template&id=23c3daea&"
import script from "./Male.vue?vue&type=script&lang=js&"
export * from "./Male.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports